import api from "../httpClient"

export type AdminMessagePayload = {
  channel: "email" | "sms"
  recipient_type: "cohort" | "scholars" | "mentors" | "custom_list"
  cohort_id?: string
  user_ids?: Array<string | number>
  subject?: string
  body: string
}

export type AdminMessageResponse = {
  message_id: string
  sent_count: number
  skipped_count: number
  failed_count: number
}

const sendAdminMessage = async (payload: AdminMessagePayload) => {
  const resp = await api.post<AdminMessageResponse>("/api/admin/messages/send/", payload)
  return resp.data
}

export const messages = {
  sendAdminMessage,
}
